import { EncryptStorage } from "encrypt-storage";
export const StoreCookie: any = new EncryptStorage("TTADMINKeyHAS", {
  prefix: "@ttadmin",
  storageType: "localStorage",
});